import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
// import { HOURLY_TIME_PERIOD } from '../../config/constants/analytics';
import SectionCard from './components/SectionCard';
import ChartTabs from './components/ChartTabs';
import LostRevenueBarChart from './BarChart/LostRevenueBarChart';
import RealizedRevenueBarChart from './BarChart/RealizedRevenueBarChart';
import GrossRevenueHeatmapChart from './Heatmap/GrossRevenueHeatmapChart';
import LostRevenueHeatmapChart from './Heatmap/LostRevenueHeatmapChart';
import { makeSelectProperty } from './selectors';

const GrossVsLostRevenueChart = ({ isTimePeriodFilterStatusChanged }) => {
  // const isHourly = selectedTimePeriod.slug === HOURLY_TIME_PERIOD; // remove heatmap
  const isHourly = false;

  const COMPARISON_TABS = [
    {
      id: 1,
      title: 'Gross Order Value',
      tabContent: <RealizedRevenueBarChart />,
    },
    {
      id: 2,
      title: 'Lost Revenue',
      tabContent: <LostRevenueBarChart />,
    },
  ];

  let tabContentOne;

  if (!isTimePeriodFilterStatusChanged) {
    tabContentOne = isHourly ? (
      <GrossRevenueHeatmapChart />
    ) : (
      <RealizedRevenueBarChart />
    );
  } else {
    tabContentOne = COMPARISON_TABS[0].tabContent;
  }
  COMPARISON_TABS[0].tabContent = tabContentOne;

  let tabContentTwo;
  if (!isTimePeriodFilterStatusChanged) {
    tabContentTwo = isHourly ? (
      <LostRevenueHeatmapChart />
    ) : (
      <LostRevenueBarChart />
    );
  } else {
    tabContentTwo = COMPARISON_TABS[1].tabContent;
  }
  COMPARISON_TABS[1].tabContent = tabContentTwo;

  const [selectedTab, setSelectedTab] = useState(COMPARISON_TABS[0].id);
  const handleChangeTab = id => {
    setSelectedTab(id);
  };

  const renderTabContent = (() => {
    const tabContentIndex = COMPARISON_TABS.findIndex(
      ct => ct.id === selectedTab,
    );
    return COMPARISON_TABS[tabContentIndex].tabContent;
  })();

  return (
    <SectionCard
      title="Gross Order Value vs Lost Revenue"
      metricKey="grossRevenue"
      className="h-full"
    >
      <div className="mb-4">
        <ChartTabs
          tabs={COMPARISON_TABS}
          selected={selectedTab}
          onSelect={handleChangeTab}
        />
      </div>
      {renderTabContent}
    </SectionCard>
  );
};

GrossVsLostRevenueChart.propTypes = {
  isTimePeriodFilterStatusChanged: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  isTimePeriodFilterStatusChanged: makeSelectProperty(
    'isTimePeriodFilterStatusChanged',
  ),
});

const withConnect = connect(mapStateToProps, null);

export default withConnect(GrossVsLostRevenueChart);
